import { MDBCard, MDBCardBody, MDBCardHeader, MDBCardText } from "mdb-react-ui-kit"
import { useParams } from 'react-router'

import {project_list} from '../ProjectsContent'
// import React from "react"

export function ProjectsDetail() {

    // index
    const { index } = useParams()

    // get_project
    const get_project = project_list[Number(index)]

    // title
    const title = get_project?.title

    // img
    const img_ = get_project?.img

    // body
    const body_ = get_project?.body


    return (
        <>
            <MDBCard>
                <MDBCardHeader className={'text-uppercase'}>{title}</MDBCardHeader>
                <MDBCardBody>
                    {/* <MDBCardTitle className={'text-uppercase fw-bolde'}>{title}</MDBCardTitle> */}
                    <img className={'float-start m-2 mt-0 ms-0'} style={{ height: '200px' }} src={`${img_}`} alt={`image_${index}`} />
                    <MDBCardText className={'border border-0 border-danger'}>
                        {
                            body_?.map(
                                para => <p className={'fw-light'}>{para}</p>
                            )
                        }
                    </MDBCardText>
                </MDBCardBody>
            </MDBCard>
        </>
    )

}